<template>
  <div class="home">
    <div class="adv" v-html="adv">

    </div>
    <div class="tips" v-show="!isWX">在微信端打开可获取微信抬头～</div>
    <div class="type">
      <p class="label">抬头类型</p>
      <van-radio-group :disabled="form.flag !== 2 && form.flag !== 5" v-model="form.customer_title_type" @change="changeType">
        <van-radio name="个人" checked-color="#00a900">个人</van-radio>
        <van-radio name="单位" checked-color="#00a900">单位</van-radio>
      </van-radio-group>
    </div>
    <div class="form">
      <div class="name">
        <p class="label">抬头名称</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" :class="{err:titleIsNull}" type="text" placeholder="抬头(必填)" v-model="form.customer_title" ref="title">
        </p>
      </div>
      <div class="source" v-show="isWX && (form.flag === 2 || form.flag === 5) ">
        <van-button type="primary" @click='getWXVoice'>微信抬头</van-button>
        <van-button type="primary" @click="historyTitle">历史抬头</van-button>
      </div>
      <div class="tax" v-show="form.customer_title_type === '单位'">
        <p class="label">税号</p>
        <p class="input">
          <input onkeyup="value=value.replace(/[^\w\/]/ig,'')" :disabled="form.flag !== 2 && form.flag !== 5" :class="{err:taxIsNull}" type="text" placeholder="15-20位(必填)" v-model="form.customer_taxno" ref="tax">
        </p>
      </div>
      <div class="back" v-show="form.customer_title_type === '单位'">
        <p class="label">开户行</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" type="text" placeholder="开户行" v-model="form.customer_bank_name">
        </p>
      </div>
      <div class="back" v-show="form.customer_title_type === '单位'">
        <p class="label">账号</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" type="text" placeholder="账号" v-model="form.customer_bank_acc">
        </p>
      </div>
      <div class="phone" v-show="form.customer_title_type === '单位'">
        <p class="label">地址、电话</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" type="text" placeholder="地址、电话" v-model="form.customer_addr">
        </p>
      </div>
      <div class="phone">
        <p class="label">发票接收手机</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" :class="{err:phoneIsNull}" type="text" placeholder="电话" v-model="form.customer_phone" ref="phone">
        </p>
      </div>
      <div class="email">
        <p class="label">发票接收邮箱</p>
        <p class="input">
          <input :disabled="form.flag !== 2 && form.flag !== 5" type="text" placeholder="邮箱地址" v-model="form.customer_mail" @blur="blurEmail">
        </p>
      </div>
    </div>
    <div class="shopInfo">
      <ul>
        <li>
          <p>票据单号</p>
          <p>{{form.system_no}}</p>
        </li>
        <li>
          <p>商品项目</p>
          <p>{{form.biz_order_name}}</p>
        </li>
        <li>
          <p>商品金额</p>
          <p>{{form.biz_order_money}}</p>
        </li>
        <li>
          <p>销方名称</p>
          <p>{{form.biz_info.biz_name}}</p>
        </li>
        <li>
          <p>票据时间</p>
          <p>{{form.createtime}}</p>
        </li>
      </ul>
    </div>
    <div class="submit" @click="submit">
      <p v-show="form.flag === 2 || form.flag ===5">开票</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === 1">资料已经提交，请等待...</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === 0">查看发票</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === 4">开票码已过期</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === 3">发票已删除</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === -1">资料已经进入审核过程</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === -2">发票请求处理中</p>
      <p style="backgroundColor:#a8bda8" v-show="form.flag === -3">发票抬头错误</p>
    </div>
    <div class="rback" v-show="reurl">
      <p @click="back">返回</p>
    </div>
    <!-- <div class="send-email" @click="sendEmail" v-show="form.flag === 0">
      <p>重发邮件</p>
    </div> -->
    <van-dialog
      v-model="showHistory"
      show-cancel-button
      confirm-button-color="#00a900"
      @confirm="confirmHistoryTitle">
      <van-radio-group v-model="historyTitleNo">
        <van-radio checked-color="#00a900" :name="index" v-for="(item,index) in historyTitleData" :key="index">
          <div>
            <p>{{item.com_name || ''}}</p>
            <p>{{item.com_taxno || ''}}</p>
          </div>
        </van-radio>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import wx from 'weixin-js-sdk'
import { ls } from '../utils/common.js'
import { Toast, Dialog } from 'vant'
export default {
  name: 'home',
  components: {
  },
  methods: {
    // 点击微信抬头获取微信的抬头
    getWXVoice () {
      // 测试号没有该权限
      let _this = this
      wx.ready(function () {
        wx.invoke('chooseInvoiceTitle', { 'scene': '1' }, function (result) {
          let res = JSON.parse(result.choose_invoice_title_info)
          _this.form.customer_title = res.title
          _this.form.customer_taxno = res.taxNumber
          _this.form.customer_bank_name = res.bankName
          _this.form.customer_bank_acc = res.bankAccount
          _this.form.customer_addr = `${res.companyAddress} ${res.telephone}`
          if (res.type === '1') {
            _this.form.customer_title_type = '个人'
          } else {
            _this.form.customer_title_type = '单位'
          }
        })
      })
    },
    // 获取发票商品信息
    getShopInfo () {
      this.$axios.get('/getShopInfo', { params: { system_no: this.system_no } }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.biz_uid = res.data.biz_uid
          if (!res.data.customer_title_type) {
            res.data.customer_title_type = '单位'
          }
          this.form = res.data
          this.getAdv()
        } else if (res.code === 500) {
          this.$router.push({ name: 'error' })
        }
      })
    },
    blurEmail () {

    },
    // 开票（先确认抬头和税号是否为空）
    submit () {
      if (this.form.flag !== 2 && this.form.flag !== 5) {
        if (this.form.flag === 0) {
          // console.log(this.form.invoice_file)
          location.href = this.form.invoice_file
          return false
        }
        if (this.ua.match(/micromessenger/i) && this.ua.match(/micromessenger/i)[0] === 'micromessenger') {
          wx.closeWindow()
        } else if (this.ua.indexOf('firefox') !== -1 || this.ua.indexOf('chrome') !== -1) {
          window.open('', '_self').close()
        } else {
          window.opener = null
          window.open('about:blank', '_self')
          window.close()
        }
        return false
      }
      if (!this.form.customer_title) {
        this.titleIsNull = true
        if (this.form.customer_title_type === '单位') {
          this.$refs.title.placeholder = '抬头不能为空 (必填)'
        } else {
          this.$refs.title.placeholder = '请填写个人或您的姓名'
        }
        return false
      }
      if (!this.form.customer_taxno && this.form.customer_title_type === '单位') {
        this.taxIsNull = true
        this.$refs.tax.placeholder = '税号不能为空 15-20位(必填)'
        return false
      }
      if (this.form.customer_taxno && this.form.customer_title_type === '单位') {
        if (this.form.customer_taxno.length !== 15 && this.form.customer_taxno.length !== 18 && this.form.customer_taxno.length !== 20 && this.form.customer_taxno.length !== 21) {
          this.taxIsNull = true
          // this.$refs.tax.placeholder = '税号格式错误'
          Dialog.alert({
            title: '税号格式错误',
            message: '税号格式错误，长度必须15,18,20,21位字符串,请检查长度是否正确及是否有非法字符（如空格及中式英文）'
          }).then(() => {
            // on close
          })
          return false
        }
      }
      if (!this.form.customer_phone && !this.form.customer_mail) {
        this.phoneIsNull = true
        this.$refs.phone.placeholder = '手机或邮箱必须填一个'
        return false
      }
      if (this.form.customer_phone && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.customer_phone))) {
        this.phoneIsNull = true
        this.$refs.phone.placeholder = '手机号码格式不正确'
        return false
      }
      this.form.flag = 1
      let params = { ...this.form }
      // 开票
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中'
      })
      this.$axios.post(`/snedInvoiceInfo?openid=${this.openid}`, params).then((result) => {
        console.log(result)
        Toast.clear()
        if (result.code === 0) {
          Toast.success('开票中(24小时内完成)')
        }
      })
    },
    // 历史抬头
    historyTitle () {
      this.$axios.get('/historyTitle', { params: { openid: this.openid } }).then(res => {
        if (res.data.length > 0) {
          this.historyTitleData = res.data
          this.showHistory = true
        } else {
          Toast.fail('不存在历史抬头')
        }
      }).catch(err => {
        alert(err)
      })
    },
    // 确认选择历史抬头
    confirmHistoryTitle () {
      console.log(parseInt(this.historyTitleNo))
      let data = this.historyTitleData[parseInt(this.historyTitleNo)]
      this.form.customer_title = data.com_name
      this.form.customer_taxno = data.com_taxno
      this.form.customer_bank_name = data.bank_name
      this.form.customer_bank_acc = data.bank_account
      this.form.customer_addr = data.com_address
      this.form.customer_phone = data.com_phone
      this.form.customer_mail = data.contact_email
      this.form.customer_title_type = '单位'
    },
    // 修改抬头类型
    changeType (type) {
      if (this.form.customer_title_type !== '单位') {
        this.titleIsNull = false
        this.taxIsNull = false
        this.phoneIsNull = false
        this.form.customer_taxno = ''
        this.$refs.title.placeholder = '请填写个人或您的姓名'
      } else {
        this.$refs.title.placeholder = '抬头(必填)'
      }
    },
    // 重发邮件
    sendEmail () {
      this.$axios.post('/sendEmail', { email: this.form.customer_mail, system_no: this.system_no }).then(res => {
        console.log(res)
      })
    },
    // 获取广告
    getAdv () {
      this.$axios.get('/getAdv', { params: { biz_uid: this.biz_uid, flag: this.form.flag } }).then(res => {
        console.log(this.form)
        if (res.code === 0) {
          if (this.form.flag === 2 || this.form.flag === 5) {
            this.adv = res.data.kp_post
          } else if (this.form.flag === 0 || this.form.flag === 9) {
            this.adv = res.data.kp_down
          } else {
            this.adv = res.data.kp_chk
          }
        }
      })
    },
    back () {
      window.location.href = this.reurl
    }
  },
  data () {
    return {
      isWX: false,
      form: {
        customer_title_type: '',
        customer_title: '',
        customer_taxno: '',
        customer_bank_name: '',
        customer_bank_acc: '',
        customer_phone: '',
        customer_addr: '',
        customer_mail: '',
        system_no: '',
        biz_order_name: '',
        biz_order_money: '',
        createtime: '',
        biz_info: {
          biz_name: ''
        }
      },
      titleIsNull: false,
      taxIsNull: false,
      phoneIsNull: false,
      openid: 0,
      system_no: '',
      showHistory: false,
      historyTitleNo: '0',
      historyTitleData: [],
      adv: '',
      reurl: ''
    }
  },
  created () {
    this.system_no = this.$route.query.system_no
    this.reurl = this.$route.query.reurl
    // 判断是否是微信打开,是则显示微信抬头
    this.ua = navigator.userAgent.toLowerCase()
    this.openid = ls.get('openid')
    if (this.ua.match(/micromessenger/i) && this.ua.match(/micromessenger/i)[0] === 'micromessenger') {
      this.isWX = true
      let timestamp = new Date().getTime()
      let nonceStr = 'camie'
      let url = window.location.href
      this.$axios.get('/getSignature', { params: { timestamp, nonceStr, url } }).then(result => {
        console.log(result)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: 'wx11aa2e4f0951c676', // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature: result, // 必填，签名
          beta: true,
          jsApiList: [
            'chooseInvoiceTitle',
            'getLocation',
            'openLocation'
          ] // 必填，需要使用的JS接口列表
        })
      })
    }
    this.getShopInfo()
    // this.sendEmail()
  }
}
</script>
<style lang="less">
  .home{
    .type{
      .van-radio-group{
        display: flex;
        justify-content: space-around;
        flex:1;
      }
      .van-radio__label{
        font-size: 3.5vw;
      }
    }
    .van-button--normal{
      margin-right: 4vw;
      height: 8vw;
      line-height: 8vw;
      background-color: #00a900;
      font-size: 3vw;
    }
    .van-dialog .van-radio-group{
      padding:3vw;
      .van-radio{
        margin: 3vw;
        font-size: 3.5vw;
        text-align: left;
      }
      .van-radio__label{
        margin-left:8vw;
      }
    }
    .van-dialog{
      .van-dialog__content{
        max-height: 350px;
        overflow: auto;
      }
    }
  }
</style>
<style lang="less" scoped>
  .home{
    padding: 3vw 4vw;
    .adv{
      width:92vw;
    }
    .tips{
      color: crimson;
      font-size: 3vw;
      background-color: #e6e3e3;
      padding: 10px;
    }
    .type{
      display: flex;
      height:14vw;
      align-items: center;
      border-bottom:0.2vw solid rgba(0,0,0,0.1);
      .label{
        padding-left: 4vw;
        width: 30vw;
        text-align: left;
        font-size:3.5vw;
          color:#000000;
      }
    }
    .form{
      padding: 0 0 0 4vw;
      .name{
        border-bottom:0.2vw solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        .label{
          font-size:3.5vw;
          color:#000000;
          width:30vw;
          text-align: left;
        }
        .input{
          flex: 1;
          padding: 3vw 0;
          text-align: left;
          font-size:3.5vw;
          color:#000000;
          input{
            width: 100%;
          }
          .err::placeholder{
            color:red;
          }
        }
      }
      .source{
        text-align: left;
        padding: 3vw 0;
        border-bottom:0.2vw solid rgba(0,0,0,0.1);
      }
      .tax{
        border-bottom:0.2vw solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        .label{
          font-size:3.5vw;
          color:#000000;
          width:30vw;
          text-align: left;
        }
        .input{
          flex: 1;
          padding: 3vw 0;
          text-align: left;
          font-size:3.5vw;
          color:#000000;
          input{
            width: 100%;
          }
          .err::placeholder{
            color:red;
          }
        }
      }
      .back{
        border-bottom:0.2vw solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        .label{
          font-size:3.5vw;
          color:#000000;
          width:30vw;
          text-align: left;
        }
        .input{
          flex: 1;
          padding: 3vw 0;
          text-align: left;
          font-size:3.5vw;
          color:#000000;
          input{
            width: 100%;
          }
        }
      }
      .phone{
        border-bottom:0.2vw solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        .label{
          font-size:3.5vw;
          color:#000000;
          width:30vw;
          text-align: left;
        }
        .input{
          flex: 1;
          padding: 3vw 0;
          text-align: left;
          font-size:3.5vw;
          color:#000000;
          input{
            width: 100%;
          }
          .err::placeholder{
            color:red;
          }
        }
      }
      .email{
        display: flex;
        align-items: center;
        .label{
          font-size:3.5vw;
          color:#000000;
          width:30vw;
          text-align: left;
        }
        .input{
          flex: 1;
          padding: 3vw 0;
          text-align: left;
          font-size:3.5vw;
          color:#000000;
          input{
            width: 100%;
          }
        }
      }
    }
    .shopInfo{
      background-color: #e1e1e3;
      ul{
        padding:0 4vw;
        li{
          display: flex;
          align-items: center;
          font-size:3.5vw;
          color:#000000;
          padding:3vw 0;
          p:first-child{
            width:30vw;
            text-align: left;
          }
        }
      }
    }
    .submit{
      padding:4vw;
      p{
        background-color: #00a900;
        color:#fff;
        padding: 3vw 0;
        border-radius: 2px;
        font-size: 4vw;
      }
    }
    .send-email{
      padding:0 4vw;
      p{
        background-color: #00a900;
        color:#fff;
        padding: 3vw 0;
        border-radius: 2px;
        font-size: 4vw;
      }
    }
    .rback{
      padding:4vw;
      >p{
        background-color: #00a900;
        color:#fff;
        padding: 3vw 0;
        border-radius: 2px;
        font-size: 4vw;
      }
    }
  }
</style>
